import { api } from '@api/axios';

export interface GroupSettingsResponse {
  id: string;
  name: string;
  description: string | null;
  host: string;
  status: number;
  type: number;
  webClientType?: number;
  settings: {
    colors: {
      denary: string;
      nonary: string;
      senary: string;
      primary: string;
      quinary: string;
      octonary: string;
      tertiary: string;
      secondary: string;
      septenary: string;
      quaternary: string;
    };
    images: {
      logo: string;
      welcome: string;
      emailHeader: string;
      emailFooter: string;
      favIcon: string;
      background?: string;
    };
    emails: { primary: string; secondary: string | null };
    phones: { primary: string; secondary: string | null };
    texts: {
      welcomeText: string;
      welcomeTitle: string;
      registrationText?: string;
      registrationTitle?: string;
    };
    fonts?: { primary?: string; secondary?: string | null; tertiary?: string | null };
    landing?: LandingSettings | null;
    tracking?: TrackingEntry[] | null;
  };
  plans?: { planId: number }[];
  phqEnabled?: boolean;
}

export enum TrackingProvider {
  Google = 'google',
  GoogleTagManager = 'googleTagManager',
  Facebook = 'facebook',
}

export interface TrackingEntry {
  type?: string | null;
  value?: string | null;
  provider?: TrackingProvider | string | null;
}

export interface LandingSettings {
  enabled?: boolean | null;
  caption?: string | null;
  hero?: string | null;
  secondary?: string | null;
  qualify?: string | null;
}

export class GroupsService {
  static async getByHash(groupHash: string): Promise<GroupSettingsResponse> {
    const { data } = await api.get<GroupSettingsResponse>(
      `/groups/${groupHash}`
    );
    return data;
  }
}
